import { useBreadCrumbsQueryQuery } from "@src/components/atoms/Breadcrumbs/__generated/Breadcrumbs.generated";
import { QueryClient } from "@tanstack/react-query";
import  flatMapDeep from "lodash/flatMapDeep";

export type IBreadcrumb = {
  name: string;
  slug: string;
}

export const getBreadcrumbsGql = async ({
  queryClient,
  preview,
  slug,
}: {
  queryClient: QueryClient;
  preview: boolean;
  slug: string;
}): Promise<IBreadcrumb[]> => {
  await queryClient.prefetchQuery(
        // @ts-ignore
    useBreadCrumbsQueryQuery.getKey({ preview, slug }),
    // @ts-ignore
    useBreadCrumbsQueryQuery.fetcher({ preview, slug })
  );

  const { pageCollection } = await useBreadCrumbsQueryQuery.fetcher({
        // @ts-ignore

    preview,
    slug,
  });

  const flatten = (item: any, data: any[]): any[] => {

    let d = data;
    if (item && item.parentPage) {
      d = flatten(item?.parentPage, data);
    }

    d.push({ name: item?.name, slug: item?.slug });

    return d;
  }

  const breadcrumbs = flatten(pageCollection?.items[0], []);



  return breadcrumbs;
};
